import { supabase } from "../utils/supabaseClient";

export async function getUserProfile(token) {
  const { data: { user }, error } = await supabase.auth.getUser();

  if (error) throw error;
  if (!user) throw new Error("User not found");

  // Try to get name from USER_PROFILES first
  const { data: profile } = await supabase
    .from('USER_PROFILES')
    .select('user_name, language, date_of_birth, gender_at_birth, country_of_birth, city_of_birth, mbti')
    .eq('user_id', user.id)
    .single();


return {
    id: user.id,
    email: user.email,
    name: profile?.user_name || user.user_metadata?.name || "",
    language: profile?.language || user.user_metadata?.language || "en",
    date_of_birth: profile?.date_of_birth || null,
    gender_at_birth: profile?.gender_at_birth || null,
    
    // MATCH THESE TO YOUR ProfilePage.js STATE
    country: profile?.country_of_birth || "", 
    city: profile?.city_of_birth || "",      
    mbti: profile?.mbti || "",               
    
    created_at: user.created_at
  };
}

export async function updateUserProfile(token, name, language, dateOfBirth, genderAtBirth, country_of_birth, city_of_birth, mbti_type) {
  // 1. Update auth metadata
  const updateData = { name };
  if (language) {
    updateData.language = language;
  }
  
  const { data: { user }, error: authError } = await supabase.auth.updateUser({
    data: updateData
  });

  if (authError) throw authError;

  // 2. Update USER_PROFILES table in Supabase
  // We upsert to ensure the record exists and update the name/email
  const profileUpdates = {
    user_id: user.id,
    email: user.email,
    user_name: name,
  };

  if (language) {
    profileUpdates.language = language;
  }

  if (dateOfBirth) {
    profileUpdates.date_of_birth = dateOfBirth;
  }

  if (genderAtBirth) {
    profileUpdates.gender_at_birth = genderAtBirth;
  }

  if (country_of_birth) {
    profileUpdates.country_of_birth = country_of_birth;
  }
  if (city_of_birth) {
    profileUpdates.city_of_birth = city_of_birth;
  }
  if (mbti_type) {
    profileUpdates.mbti = mbti_type;
  }

  const { error: dbError } = await supabase
    .from('USER_PROFILES')
    .upsert(profileUpdates, { onConflict: 'user_id' });

  if (dbError) {
    console.error("Error updating USER_PROFILES:", dbError);
    throw dbError;
  }

  return {
    id: user.id,
    email: user.email,
    name: user.user_metadata?.name || "",
    language: user.user_metadata?.language || "en",
      country_of_birth: country_of_birth || "",
      city_of_birth: city_of_birth || "",
      mbti: mbti_type || "",
    created_at: user.created_at
  };
}

export async function checkEmailExists(email) {
  // Check if email exists in Supabase USER_PROFILES table
  // This assumes USER_PROFILES has an 'email' column and is readable by public/anon
  const { data, error } = await supabase
    .from('USER_PROFILES')
    .select('user_id')
    .eq('email', email)
    .maybeSingle();

  // debug log
  console.log("Checking if email exists:", email, "Result:", data);
  
  if (error) {
    console.error("Error checking email in Supabase:", error);
    // Fallback to false so we don't block signup if check fails
    return false;
  }

  return data !== null;
}
